"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");
/**
 * Checks whether the given number is higher than defined value.
 * @author Jaroslav Sevcik
 */


var BigNumberGreaterThanValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(BigNumberGreaterThanValidator, _Validator_1$Validato);

  function BigNumberGreaterThanValidator(limit) {
    var _this;

    var orEquals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, BigNumberGreaterThanValidator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BigNumberGreaterThanValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
    _this.limit = limit;
    _this.orEquals = orEquals;
    return _this;
  }

  _createClass(BigNumberGreaterThanValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      if (!this.orEquals && value.equals(this.limit) || value.lessThan(this.limit)) {
        return new ValidationResult_1.ValidationError(BigNumberGreaterThanValidator.OUT_OF_BOUNDS_ERRORS, this.limit);
      }

      return new ValidationResult_1.ValidationSuccess(value);
    }
  }]);

  return BigNumberGreaterThanValidator;
}(Validator_1.Validator);

exports.BigNumberGreaterThanValidator = BigNumberGreaterThanValidator;
BigNumberGreaterThanValidator.OUT_OF_BOUNDS_ERRORS = 'NUMBER_BELOW_MIN';